<template>
    <icon><component :is="icon" /></icon>
</template>

<script>
import Icon from '~/patterns/atoms/icon/icon.vue';
import IconThemeGreen from '~/patterns/atoms/_icons/theme-green.vue';
import IconThemeCreative from '~/patterns/atoms/_icons/theme-creative.vue';
import IconThemeSocial from '~/patterns/atoms/_icons/theme-social.vue';
import IconProgramCircularBusiness from '~/patterns/atoms/_icons/program-circular-business.vue';
import IconProgramCultureAndMedia from '~/patterns/atoms/_icons/program-culture-and-media.vue';
import IconProgramInnovativeLocalInitiatives from '~/patterns/atoms/_icons/program-innovative-local-initiatives.vue';
import IconProgramSocialManagementAndInclusion from '~/patterns/atoms/_icons/program-social-management-and-inclusion.vue';
import IconProgramSustainableEnergy from '~/patterns/atoms/_icons/program-sustainable-energy.vue';
import IconProgramSustainableFoodSystem from '~/patterns/atoms/_icons/program-sustainable-food-system.vue';
import IconProgramBankgiroLoterijFonds from '~/patterns/atoms/_icons/program-bankgiro-loterij-fonds.vue';
import IconChevronRightLarge from '~/patterns/atoms/_icons/chevron-right-large.vue';
import IconDownload from '~/patterns/atoms/_icons/download.vue';

export default {
    components: {
        Icon,
        IconThemeGreen,
        IconThemeCreative,
        IconThemeSocial,
        IconProgramCircularBusiness,
        IconProgramCultureAndMedia,
        IconProgramInnovativeLocalInitiatives,
        IconProgramSocialManagementAndInclusion,
        IconProgramSustainableEnergy,
        IconProgramSustainableFoodSystem,
        IconProgramBankgiroLoterijFonds,
        IconChevronRightLarge,
        IconDownload
    },
    props: {
        icon: {
            type: String,
            required: true,
            default: ''
        }
    }
};
</script>
